import { pushToDataLayer } from '@app/infrastructure/gtm/pushToDataLayer';
import { GtmEventName } from '@app/domain/model/gtm/GtmEventName';
import { GtmInsuranceType } from '@app/domain/model/gtm/GtmInsuranceType';

export interface PersonalAccidentsStartCalculationData {
    insuredPersonsCount: number;
}

export function trackStartCalculation(data: PersonalAccidentsStartCalculationData): void {
    pushToDataLayer(GtmEventName.StartCalculation, {
        insurance_type: GtmInsuranceType.PersonalAccidents,
        insured_persons_count: data.insuredPersonsCount,
    });
}
